import { motion } from 'framer-motion';

/**
 * Three bouncing dots used after rotating messages.
 *
 * SOURCE: frontend-prod/features/research/components/ResearchThinkingLoader.tsx:110-129
 * (the inline `.`+`.`+`.` opacity cycle). Extracted here so the same animation
 * powers all three plugin loaders (draft, research, edit).
 */
export function AnimatedDots({ className }: { className?: string }): JSX.Element {
  return (
    <span className={`ml-1 inline-flex ${className ?? ''}`}>
      {[0, 0.3, 0.6].map((delay, i) => (
        <motion.span
          key={i}
          animate={{ opacity: [0, 1, 0] }}
          transition={{ repeat: Infinity, duration: 1, delay }}
        >
          .
        </motion.span>
      ))}
    </span>
  );
}
